import RoomInviteDetailsPanel from "./RoomInviteDetailsPanel";

/** Post-create inline invite in the lobby create section. */
export default function LobbyRoomCreatedInvite({
  roomCode,
  roomLabel,
  spectatorCode,
  refereeCode,
  inviteAbsUrl = "",
  inviteReady = true,
  inviteError = "",
  onContinue,
  onDismiss,
  dismissRef,
  continueLabel = "Continue to arena",
  dismissLabel = "Stay on home for now",
}) {
  return (
    <RoomInviteDetailsPanel
      roomCode={roomCode}
      roomLabel={roomLabel}
      playerAccessCode={spectatorCode}
      refereeCode={refereeCode}
      inviteUrl={inviteAbsUrl}
      inviteReady={inviteReady}
      inviteError={inviteError}
      lead={
        inviteReady
          ? "Share the invite link — friends sign in and enter the arena directly (no access code on the link). Arena code is a backup."
          : "Arena created. Invite link appears when the server confirms the arena is ready to join."
      }
      primaryAction={{ label: continueLabel, onClick: onContinue }}
      secondaryAction={onDismiss ? { label: dismissLabel, onClick: onDismiss } : undefined}
      secondaryButtonRef={dismissRef}
    />
  );
}
